export enum UsageAggregationScope {
  DOCUMENT = 'DOCUMENT',
  CONTRACT = 'CONTRACT',
  USAGE_REPORT = 'USAGE_REPORT',
}
